import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

// The missing info table in selection mode, for choosing the item something else (e.g. a time entry) is linked to.
// Dismisses with the chosen item, or null.
@Component({
  selector: 'app-missing-info-select',
  templateUrl: './select.component.html',
})
export class MissingInfoSelectComponent {
  @Input() max_allowed_selections = 1;
  // The contact / company the item will be linked to - only their items (and ones with nobody assigned) are shown
  @Input() client_guid = '';
  @Input() company_guid = '';
  @Input() client_name = '';
  selected: any[] = [];

  constructor(private modalController: ModalController) { }

  Select() {
    this.modalController.dismiss(this.selected[0] || null);
  }

  Close() {
    this.modalController.dismiss(null);
  }
}
